"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelperText = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const Css_1 = require("../Css");
/**
 * A helper component for consistently showing helper text below form fields.
 */
function HelperText(props) {
    const { helperText, contrast = false, ...others } = props;
    return ((0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.gray700.xs.mtPx(4).if(contrast).gray100.$, ...others, children: helperText }));
}
exports.HelperText = HelperText;
